import { baseApi } from './baseApi'

import {
  PatientStatementLookupDto,
  PatientStatementLookupResponse,
  PublicStatementDto,
} from 'store/types'

type CheckoutRequest = {
  statementId: string
  patientId: number
  successUrl: string
  cancelUrl: string
  // Omitted to pay the whole balance.
  amount?: number
}

type CheckoutResponse = { url: string }

export const patientStatementsPublicApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicStatement: builder.query<PublicStatementDto, { statementId: string; patientId: number }>({
      query: ({ statementId, patientId }) => ({
        url: `/lab/patients/${patientId}/account/statements/${statementId}/public`,
      }),
    }),
    createStatementCheckout: builder.mutation<CheckoutResponse, CheckoutRequest>({
      query: ({ statementId, patientId, ...body }) => ({
        url: `/lab/patients/${patientId}/account/statements/${statementId}/checkout`,
        method: 'POST',
        body,
      }),
    }),
    // Public: the website payment link has no statement id, the patient
    // identifies themself and gets the statement JWT plus where to go.
    lookupPatientStatement: builder.mutation<
      PatientStatementLookupResponse,
      PatientStatementLookupDto
    >({
      query: (body) => ({
        url: '/patient/auth/statement-lookup',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useGetPublicStatementQuery,
  useCreateStatementCheckoutMutation,
  useLookupPatientStatementMutation,
} = patientStatementsPublicApi
